


















import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { forEach } from "lodash";
import { answerItemBodyParser } from "../../../../helpers/question-parser";
import AnswerItem from "../../models/answer_item";

@Component({})
export default class QuestionSelect extends Vue {
  @Prop({ default: [] }) list: AnswerItem[];
  @Prop({ default: [] }) value: Array<any>;
  @Prop({ default: "" }) trueBgr: string;
  @Prop({ default: "" }) falseBgr: string;
  @Prop({ default: false }) readonly: boolean;
  @Prop({ default: () => {} }) callBackChange: Function;
  @Prop({ default: "" }) color: string;

  selected: string = "";
  items: string[] = [];

  @Watch("value")
  changeValue(val, oldVal) {
    if (val !== oldVal) {
      this.selected = val.length ? val[0] : "";
    }
  }
  @Watch("list", { immediate: true })
  changeList(val, oldVal) {
    if (val !== oldVal) {
      forEach(val, (item) => {
        this.items.push(answerItemBodyParser(item.body));
      });
    }
  }

  created() {
    if (this.value.length) {
      this.selected = this.value.length ? this.value[0] : "";
    }
  }

  getStyle(item) {
    if (this.trueBgr && item.correct) {
      return {
        "background-color": this.trueBgr,
      };
    }
    if (this.falseBgr && !item.correct) {
      return {
        "background-color": this.falseBgr,
      };
    }
  }

  onChange(val) {
    var value = val != "" ? [val] : [];
    this.callBackChange(value);
  }
}
